import React, { Component } from 'react';
import { logAsClient } from '../../actions/connectAsClient';
import { connect } from 'react-redux';

class ConnectAsClient extends Component {
  componentDidMount() {
    this.props.logAsClient(this.props.match.params.token);
  }

  render() {
    return <div />;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logAsClient: async (clientToken) => {
      localStorage.setItem('distribution_filters', '{}');
      localStorage.setItem('global_view_filters', '{}');
      await dispatch(logAsClient(clientToken));
    }
  };
};

export default connect(null, mapDispatchToProps)(ConnectAsClient);
